import { FieldProps } from 'formik';
import Options, { OptionsProps } from '../atoms/Options';

const OptionsField = ({
  field,
  form: { setFieldValue, setFieldTouched },
  meta,
  ...props
}: FieldProps & OptionsProps & { className?: string }) => (
  <Options
    {...props}
    {...field}
    onChange={value => {
      props.onChange?.(value);
      setFieldValue(field.name, value);
      setTimeout(() => setFieldTouched(field.name), 0);
    }}
  />
);

export default OptionsField;
